import {Image} from "react-bootstrap";
import React from "react";
import VerticalTabs from "../VerticalTabs";

class PlayerCard extends VerticalTabs.Item {
    renderContent() {
        const {name, teamName, score, datetime, avatar} = this.props;
        const scoreFormat = `Overall Score  - ${score}`;

        return (
            <div className="player-card">
                <Image className="avatar" src={avatar} roundedCircle={true}/>
                <div className="information">
                    <span className="information-heading">
                        <span className="name">{name}</span>
                        <time className="datetime">{datetime}</time>
                    </span>
                    <span className="team"> {teamName} </span>
                    <span className="score"> {scoreFormat} </span>
                </div>

            </div>
        );
    }
}

export default PlayerCard;
